import React, { useMemo, useContext, useState } from "react";
import _ from "lodash";

import Player from '../Player';
import FullscreenWrapper from '../FullscreenWrapper';

import { navigate } from "gatsby-link";

import { getEntityUrl } from "../../util";

import { GlobalContext } from '../../context/GlobalContext';
import { TourContext } from "../Tour/TourContext";

import './videoplayer.css';
import {LocalizedString} from "../Strings";

const Videoplayer = (props) => {
    const { component, files, pageContext, } = props;
    const { fullscreenMode } = useContext(GlobalContext);
    const { isTour, skipToNext } = useContext(TourContext);
    const [isError, setIsError] = useState(false);
    const playerRef = React.createRef();

    const { defaultLocale } = pageContext;

    const videoUrl = useMemo(() => {
        return _.find(files.nodes, { id: component.video?.localFile___NODE })?.publicURL;
    }, [files, component]);

    const onEnded = () => {
        if (isTour) skipToNext();
        else if (component.continueTo) navigate(getEntityUrl({ entity: component.continueTo, defaultLocale}));//TODO - locale working?
        else if (fullscreenMode) navigate(-1);
    }

    const onError = () => {
        setIsError(true);
    }

    //TODO - hide "fullscreen" button in app
    return (
      <FullscreenWrapper {...props} showFullscreenButton={true}>
        {videoUrl !== undefined && (
          <div className="videoplayer">
            {isError && component.onSiteOnly &&
                <LocalizedString className={"error"} string={(component.onSiteOnly ? "This audio is only available on site" : "")} locale={props.entity.locale || defaultLocale} />
            }
            <Player
              width={fullscreenMode ? "100vw" : "100%"}
              height={fullscreenMode ? "100vh" : "100%"}
              url={videoUrl}
              controls={true}
              stopOnUnmount={false}
              playing={component.autoplay || false}
              playsinline={true}
              onEnded={onEnded}
              onError={onError}
              isVideo={true}
              ref={playerRef}
              fullscreenMode={fullscreenMode}
            />
          </div>
        )}
      </FullscreenWrapper>
    )
};

export default Videoplayer;
